export { default as HomeAnimation } from "./homeAnimation.json";
export { default as LogoAnimation } from "./logoAnimation.json";
export { default as LoadingPages } from "./loadingPages.json";
export { default as LoadingAnimation } from "./loadingAnimation.json";